// Which BadgeSquare a mission status shows. Shared so a status reads the same
// wherever a mission is listed — mission cards, and the slide-over lists.
export const MISSION_STATUS_BADGE_TYPE = {
  suspended: 22,
  canceled: 23,
  interrupted: 24,
  deleted: 25,
};

// Not a mission status: a temp worker taken off a mission. Listed apart, but
// it shows in the same badge slot as the statuses above.
export const UNASSIGNED_BADGE_TYPE = 27;

// A candidature the company turned down. Its own reason replaces the label.
export const REFUSED_BADGE_TYPE = 3;
